import { Lock, Sparkles, UserPlus } from 'lucide-react'
import { useAuth } from '../contexts/useAuth'

interface AccessDeniedProps {
  title?: string
  description?: string
}

export default function AccessDenied({
  title = "Acces reserve",
  description = "Cette fonctionnalite est disponible uniquement pour les utilisateurs connectes.",
}: AccessDeniedProps) {
  const { loginWithGoogle } = useAuth()

  return (
    <section className="access-denied-wrap">
      <div className="card fade-in access-denied-card">
        <div className="access-denied-icon-wrap">
          <Lock size={30} color="var(--primary-light)" />
        </div>

        <p className="access-denied-kicker">
          Zone protegee
        </p>
        <h2 className="access-denied-title">{title}</h2>
        <p className="access-denied-description">{description}</p>

        <div className="access-denied-note">
          <Sparkles size={16} color="var(--accent)" className="access-denied-note-icon" />
          <span>Creez un compte pour debloquer inventaire, IA et recettes personnelles.</span>
        </div>

        <button className="btn btn-primary btn-full" onClick={loginWithGoogle}>
          <UserPlus size={17} />
          S'inscrire ou se connecter avec Google
        </button>
      </div>
    </section>
  )
}
